import React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchShopInfo } from "../../util/customer/httpCustomer"; 
import Container from "../shared/Container";
import logo from "../../assets/shared/dishonline-logo-white.png";
import PrimaryButtonDark from "../shared/PrimaryButtonDark";
import styles from "./Nav.module.css";

const rootUrl = `https://resto-online.be`;

const NavCustomer = () => {
   const { data, isLoading, isError, error } = useQuery({
      queryKey: ["shopInfo"],
      queryFn: fetchShopInfo,
      retry: false, // Don't retry on 404 errors
   });

   // If we're on the not-found page, don't show the shop name
   if (window.location.pathname === '/not-found') {
      return (
         <div className="px-10 pt-10">
            <nav className="bg-w br-15 border-light max-w-1920 m-a">
               <Container>
                  <div className={styles.nav}>
                     <div className="mxw-100">
                        <a href={rootUrl}>
                           <img src={logo} alt="DishOnline Logo" className={styles.defaultLogo} />
                        </a>
                     </div>
                  </div>
               </Container>
            </nav>
         </div>
      );
   }

   // Check of er een custom webshop logo is
   const shopLogo = data?.shopLogoUrl || null;
   const showShopName = !shopLogo;
   const shopName = isLoading ? "Shopnaam laden..." : isError ? "Shopnaam niet beschikbaar" : data?.shopName;

   return (
      <div className="px-10 pt-10">
      <nav className="bg-w br-15 border-light max-w-1920 m-a">
         <Container>
            <div className={styles.nav}>
               {/* DishOnline Logo (Altijd zichtbaar) */}
               <div className="mxw-100">
                  <a href={rootUrl}>
                     <img src={logo} alt="DishOnline Logo" className={styles.defaultLogo} />
                  </a>
               </div>

               {/* Webshop Logo (indien beschikbaar) of Shopnaam */}
               <div className={styles.centerContent}>
                  {shopLogo ? (
                     <img src={`${shopLogo}?t=${Date.now()}`} alt="Webshop Logo" className={styles.shopLogo} />
                  ) : (
                     <p className="f-xl">{shopName}</p>
                  )}
               </div>
               <div className={styles.hiddenMobile}></div>
            </div>
            </Container>
         </nav>
      </div>
   );
};

export default NavCustomer;
